import type { MapLayers } from 'types/map';

const mapLayers: MapLayers = {
  BUOYS: 'buoys',
  WIND_STATIONS: 'wind-stations',
  SURF_SPOTS: 'surf-spots',
};

export default mapLayers;
